import { post, get } from '@/utils/http'

export function data_user_operation_log_in (params) {
  return post({ url: '/service-user/data_user_operation_log/in', params })
}